import MuiButton, { ButtonProps } from '@mui/material/Button';

function Button(props: ButtonProps) {
  return <MuiButton {...props} />;
}

export default Button;
